export const BASE_URL = `https://${getEnvName()}foldhealth.io`;
export const CRM_BASE_URL = BASE_URL + '/crm-nest';
export const CRM_PUBLIC_BASE_URL = CRM_BASE_URL + '/public';
export const FHIR_BASE_URL = `https://${getEnvName()}foldhealth.io/integration/fhir`;
export const HASURA_SECRET = 'asdf1234';

export const WORKFLOW_SERVICE_URL = BASE_URL + '/workflow-nest/';
export const CLOUD_TELEPHONY_SERVICE_URL = BASE_URL + '/cloud-telephony/';

export const CONTEXT = 'account';
export const CONTEXT_PLATFORM = 'platform';
export const CRM_GRAPHQL_URL = `${CRM_BASE_URL}/${CONTEXT_PLATFORM}`;
export const GRAPHQL_PLATFORM_URL = `${CRM_BASE_URL}/${CONTEXT_PLATFORM}`;

// Cloud Telephony
export const CLOUD_TELEPHONY_GRAPHQL_URL =
  BASE_URL + '/cloud-telephony/service/graphql';
export const CLOUD_TELEPHONY_APOLLO_CONTEXT = 'cloudTelephony';

// fhir
export const FHIR_APOLLO_CONTEXT = `fhir`;

// Feed

export const FEED_SERVICE_URL = `${BASE_URL}/feed-service/v1/graphql`;
// export const FEED_SERVICE_URL = `http://localhost:4000/graphql`;
export const FEED_SERVICE_APOLLO_CONTEXT = 'feedService';
export const PATIENT_EDUCATION_URL = `${BASE_URL}/viewer/articles/`;

// Care Studio
export const CARESTUDIO_APOLLO_CONTEXT = 'carestudio';
export const CARESTUDIO_PROXY_TO_CRM_CONTEXT = 'care_studio_proxy_to_crm';
// -- AWS carestudio config --
// export const CARE_STUDIO_NEST_URL = `http://localhost:9090`;
export const CARE_STUDIO_NEST_URL = `${BASE_URL}/carestudio-nest`;
export const CARE_STUDIO_MIDDLEWARE_URL = `${CARE_STUDIO_NEST_URL}/graphql`;
export const CARE_STUDIO_PROXY_TO_CRM_URL = `${CARE_STUDIO_NEST_URL}/proxy/crm-nest/platform`;
//export const CARE_STUDIO_PROXY_TO_CRM_URL = `http://localhost:9090/proxy/crm-nest/platform`;
export const FORM_FILE_S3_URL = {
  UPLOAD: `${CARE_STUDIO_NEST_URL}/attachment/upload`,
  FILE_GET: `${CARE_STUDIO_NEST_URL}/attachment/#ATTACHMENT_ID/file`,
  FILE_DETAIL_GET: `${CARE_STUDIO_NEST_URL}/attachment/#ATTACHMENT_ID`,
};
//export const HASURA_SECRET = 'PisC]MKN2U';

export const ZOOM_SDK_KEY = 'wLXKKeedyTjVhSwsKa208MuBz3kaKOrXIiQ9';

export const PUBLIC_API_TOKEN = (): string => {
  // return getEnvVariable() === 'dev' ? '_eeCS}ZuJj' : 'W?v6EG{g74';
  if (getEnvVariable() === 'dev') {
    return '_eeCS}ZuJj';
  } else if (getEnvVariable() === 'sandbox') {
    return 'W?v6EG{g74';
  } else if (getEnvVariable() === 'qa') {
    return 'SOZ6i4P3J#';
  } else {
    return 'W?v6EG{g74';
  }
};

export function getEnvVariable() {
  if (window.location.host.includes("localhost")) {
    return "sandbox";
  } else if (window.location.host.includes(".sandbox.foldhealth.io")) {
    return "sandbox";
  } else if (window.location.host.includes(".dev.foldhealth.io")) {
    return "dev";
  } else if (window.location.host.includes(".qa.foldhealth.io")) {
    return "qa";  
  } else if (window.location.host.includes(".foldhealth.net")) {
    return "astrana-qa";
  } else if (window.location.host.includes(".astrana.foldhealth.io")) {
    return "astrana-prod";
  } else {
    return '';
  }
}

export function getEnvName() {
  return getEnvVariable().length ? `${getEnvVariable()}.` : '';
}

// -- Local carestudio config --
export default {
  BASE_URL,
  CONTEXT,
  CRM_GRAPHQL_URL,
  CARE_STUDIO_MIDDLEWARE_URL,
  GRAPHQL_PLATFORM_URL,
  FORM_FILE_S3_URL,
  CARESTUDIO_APOLLO_CONTEXT,
  HASURA_SECRET,
  PATIENT_EDUCATION_URL,
  CARE_STUDIO_NEST_URL,
  FHIR_APOLLO_CONTEXT,
  ZOOM_SDK_KEY,
  CARESTUDIO_PROXY_TO_CRM_CONTEXT,
  CARE_STUDIO_PROXY_TO_CRM_URL,
  CLOUD_TELEPHONY_GRAPHQL_URL,
  CLOUD_TELEPHONY_APOLLO_CONTEXT,
};
